import React, { useEffect } from 'react';
import { trackEvent } from 'app/utils/useCommonTracking';
import { RejectionType } from 'app/constants/enums';
import FailureState from 'app/components/customer/dashboard/FailureState';

export default () => {
  useEffect(() => {
    trackEvent('Viewed Protocol Health Ineligible Page');
  }, []);

  return <FailureState state={RejectionType.HealthRejected} />;
};
